<template>
    <div>
        <table class="mobileTable">
            <thead>
            <tr>
                <th>姓名</th>
                <th>未成交未填写行业</th>
                <th>暂停自动跟进</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in UserDataReportTip.StdQuery" :class="index%2==0?'stripe':''">
                <td>
                    {{ item.CPName }}
                </td>
                <td @click="goToList(item)" :class="item.Users>0?'link':''"> {{ item.Users }}
                </td>
                <td @click="goToPauseList(item)" :class="item.PauseUsers>0?'link':''"> {{ item.PauseUsers }}
                </td>
            </tr>
            </tbody>
        </table>

    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            UserDataReportTip: {
                StdQuery: []
            }
        }
    },
    created() {
        this.get_data()
    },
    methods: {
        goToPauseList(item, type) {
            this.$router.push({
                path: "/manager/pause_list",
                query: {
                    RelUserId: item.UserId
                }
            });
        },
        goToList(item, type) {
            this.$router.push({
                path: "/manager/userData_list",
                query: {
                    RelUserId: item.UserId
                }
            });
        },
        async get_data() {
            this.UserDataReportTip = await this.$frame.getStdQueryData("UserDataReportTip", {})
        }
    }
}
</script>

<style lang="scss" scoped>
.link {
  color: #1989fa !important;
  text-decoration-line: underline;
  text-underline-offset: 3px;
  text-decoration-color: #1989fa;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}
</style>